// src/components/LanguageSwitcher.js — public pages: a segmented control with
// the language names (no flag emoji: a flag is a country, not a language).
import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'es', label: 'ES', name: 'Español' },
  { code: 'zh', label: '中文', name: '中文' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = String(i18n.language || 'fr').slice(0, 2);

  return (
    <div className="language-switcher u-seg" role="group" aria-label="Langue / Language">
      {LANGUAGES.map(({ code, label, name }) => (
        <button
          key={code}
          type="button"
          className={`u-seg__btn ${current === code ? 'is-active' : ''}`}
          aria-pressed={current === code}
          onClick={() => i18n.changeLanguage(code)}
          lang={code}
          title={name}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
